export default __webpack_public_path__ + "static/media/fw-charlotte-er-Rose Gold.100460c1.mp4";